<template>
  <div>

    <Spinner v-if="loading === true" />
    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button" />
    </div>
    <basic-table
      v-if="loading === false"
      :selectedPage = "'general_settings'"
      ref="table"
      :columns="columns"
      :values="rows"
      @choosenObject="catchMsg($event)"

    />
    <Content :text="content"/>
  </div>
</template>
<script>
import BasicTable from '../../../shared/tables/BasicTable.vue'
import contactRequestsService from '../../../services/contactRequestsService'
import Spinner from '@/shared/loader/Spinner'
import Content from './content'

export default {
  components: {
    Spinner,
    BasicTable,
    Content
  },
  data() {
    return {
      loading: false,
      content: '',
      editedService: '',
      columns: [
        {
          label: 'Sender',
          field: 'name',
        },
        {
          label: 'Subject',
          field: 'subject',
        },
        {
          label: 'Phone',
          field: 'phone',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Message',
          field: 'message',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getcontactRequests()
  },

  methods: {
    getcontactRequests(withLoading = true) {
      this.loading = true
      contactRequestsService.index().then(response => {
        this.rows = response.data.data
        console.log(this.rows)
        this.loading = false
      })
    },
    catchMsg(msgObj){
      console.log(msgObj);
      this.content = msgObj.message
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
